import { AxiosError } from 'axios';

export const AccountReceivableErrors: Record<string, string> = {
  'financial.errors.installment.payable.already.paid':
    'A parcela já foi liquidada',
  'ultracar.errors.resource_not_found': 'O recurso não foi encontrado',

  'financial.errors.installment.receivable.already.edited.situation':
    'Parcela já foi alterada o status, recarregaremos a tela!',
};

export function handleInstallmentAlreadyEdited(error: AxiosError) {
  if (
    error.response?.data.message?.includes(
      'financial.errors.installment.receivable.already.edited.situation',
    )
  ) {
    return true;
  }
  return false;
}
